import { render } from "./page-direction.vue?vue&type=template&id=f9d214ae&scoped=true"
import script from "./page-direction.vue?vue&type=script&lang=js"
export * from "./page-direction.vue?vue&type=script&lang=js"

import "./page-direction.vue?vue&type=style&index=0&id=f9d214ae&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d214ae"]])

export default __exports__